import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-facilities',
  templateUrl: './student-facilities.component.html',
  styleUrls: ['./student-facilities.component.scss']
})
export class StudentFacilitiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
